module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "alert-tick",
    class: _vm.css_class,
    attrs: {
      "title": _vm.message,
      "data-toggle": "tooltip",
      "data-placement": "bottom"
    }
  }, [_vm._v("!")]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f445346!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/header_actions/alert_tick.vue
// module id = 1066
// module chunks = 1